import type { ReactNode } from "react";
import { BrandLogo } from "@/components/brand-logo";

/** Full-page notice for routes that cannot render, such as not-found and error boundaries. */
export function StatusPage({
  eyebrow,
  title,
  description,
  children,
}: {
  eyebrow: string;
  title: string;
  description: string;
  children: ReactNode;
}) {
  return (
    <main className="flex min-h-svh flex-col items-center justify-center px-6 py-16">
      <div className="w-full max-w-sm text-center">
        <a href="/" aria-label="Creative Strategies Atlas home" className="mx-auto mb-10 block w-fit">
          <BrandLogo className="h-8" priority />
        </a>
        <p className="text-xs font-semibold tracking-[0.2em] text-primary uppercase">{eyebrow}</p>
        <h1 className="mt-3 text-2xl font-semibold tracking-tight text-balance text-foreground">{title}</h1>
        <p className="mt-3 text-sm leading-6 text-pretty text-muted-foreground">{description}</p>
        <div className="mt-8 flex flex-col-reverse justify-center gap-2 sm:flex-row">{children}</div>
      </div>
    </main>
  );
}
